import {
    Drawer,
    Table,
    Icon,
    Tag,
    Card,
    notification,
    Button,
    Tooltip,
    Input,
    DatePicker
} from "antd";
import React from "react";
import { connect } from "react-redux";
import Request, { MEDIA_URL } from "../../request";
import FileViewer from "react-file-viewer";
import { TableComp } from "sz-react-utils";
const { RangePicker } = DatePicker;

/* ==============================
Agreement Preview Drawer
================================ */
class ShowUniversityAgreement extends React.Component {
    state = { visible: true };

    onError = () => {
        notification.error({
            message: "File type not supported, try downloading it."
        });
        this.close();
    };

    close = () => {
        this.setState({ visible: false });
        setTimeout(() => this.props.onClose(), 300);
    };



    render() {
        const { record } = this.props;
        const { visible } = this.state;

        return (
            <Drawer
                title="University Agreement"
                placement="right"
                onClose={this.close}
                visible={visible}
                width={800}
            >
                <Card>
                    <FileViewer
                        fileType="pdf"
                        filePath={`${MEDIA_URL}${record && record[0] ? record[0].url : ""}`}
                        onError={this.onError}
                    />
                </Card>
            </Drawer>
        );
    }
}

/* ==============================
Main Approval Drawer
================================ */
class UniversityCourseCommApporvalDrawer extends React.Component {
    state = {
        visible: true,
        loading: false,
        count: 0,
        arr: [],
        showAgreementDrawer: false,
        agreementRecord: null,
        currentPage: 1,
        pageSize: 10
    };

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            this.setState({ loading: true });

            try {
                params.status = "Pending";
                const res = await Request.getUniversityCourseCommissions(params);
                this.setState({
                    arr: res && res.data ? res.data : [],
                    count: res && res.total ? res.total : 0
                })
                return resolve(res);
            } catch (e) {
                notification.error({ message: "Failed to load data" });
            } finally {
                this.setState({ loading: false });
            }
        })
    }

    componentDidMount() {
        // this.loadApis();
    }

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    onClose = () => {
        this.setState({ visible: false });
        setTimeout(() => this.props.onClose(), 300);
    };


    /* ==============================
    API Loader (SAFE)
    ================================ */
    loadApis = async (params = {}) => {
        this.setState({ loading: true });

        try {
            const res = await Request.getPendingUniversityCommApproval(params);
            this.setState({
                arr: res && res.data ? res.data : [],
                count: res && res.total ? res.total : 0
            });
        } catch (e) {
            notification.error({ message: "Failed to load data" });
        } finally {
            this.setState({ loading: false });
        }
    };

    /* ==============================
    Approve / Disapprove
    ================================ */
    updateUniversityAgreement = async (id, status) => {

        const { arr } = this.state;
        const record = arr.find(item => item._id === id);
        if (!record) return;

        this.setState({ loading: true });

        const payload = {
            _id: record._id,
            status
        };

        try {
            const res = await Request.updateCourseCommissionStatus(payload);
            // const res = await Request.updateUniversityCommissionStatus(payload);

            if (res && res.success) {
                notification.success({ message: res.message });
                this.table.current.reload();
            } else {
                notification.error({ message: res.message || "Action failed" });
            }
        } catch (e) {
            notification.error({ message: "Something went wrong" });
        } finally {
            this.setState({ loading: false });
        }
    };

    /* ==============================
    Agreement Drawer
    ================================ */
    openAgreement = record => {
        this.setState({
            showAgreementDrawer: true,
            agreementRecord: record
        });
    };

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() => confirm()}
                    style={{ width: 188, marginBottom: 8, display: "block" }}
                />
                <Button
                    type="primary"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                    onClick={() => confirm()}
                >
                    Search
                </Button>
                <Button
                    size="small"
                    style={{ width: 90 }}
                    onClick={() => clearFilters()}
                >
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
                : false
    });

    closeAgreement = () => {
        this.setState({
            showAgreementDrawer: false,
            agreementRecord: null
        });
    };

    render() {
        const { title, bgColorClass, icon } = this.props.param;
        const {
            visible,
            loading,
            count,
            arr,
            showAgreementDrawer,
            agreementRecord
        } = this.state;


        const columns = [
            {
                title: "Sr.",
                width: 60,
                fixed: "left",
                render: function (_, __, index) {
                    return index + 1;
                }
            },
            {
                title: "Action",
                width: 120,
                fixed: "left",
                render: (_, record) => (
                    <>
                        <Tooltip title="Approve">
                            <Button
                                size="small"
                                shape="circle"
                                icon="check"
                                loading={loading}
                                onClick={() =>
                                    this.updateUniversityAgreement(record._id, "Active")
                                }
                            />
                        </Tooltip>
                        <Tooltip title="Disapprove">
                            <Button
                                size="small"
                                shape="circle"
                                icon="close"
                                style={{ marginLeft: 5 }}
                                loading={loading}
                                onClick={() =>
                                    this.updateUniversityAgreement(record._id, "Inactive")
                                }
                            />
                        </Tooltip>
                    </>
                )
            },
            {
                title: "University Name",
                dataIndex: "universityInstitutionName",
                key: "universityInstitutionName",

                render: function (text) {
                    return text || "-";
                },

                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <div style={{ padding: 8 }}>
                        <Input
                            placeholder="Search University"
                            value={selectedKeys[0] || ""}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                            }}
                            style={{ marginBottom: 8, display: "block" }}
                            onPressEnter={() => {
                                confirm();

                                setTimeout(() => {
                                    if (this.table && this.table.current) {
                                        this.table.current.reload();
                                    }
                                }, 0);
                            }}
                        />

                        <Button
                            type="primary"
                            size="small"
                            style={{ width: 90, marginRight: 8 }}
                            onClick={() => {
                                confirm();

                                setTimeout(() => {
                                    if (this.table && this.table.current) {
                                        this.table.current.reload();
                                    }
                                }, 0);
                            }}
                        >
                            Search
                        </Button>

                        <Button
                            size="small"
                            style={{ width: 90 }}
                            onClick={() => {
                                clearFilters();

                                setTimeout(() => {
                                    if (this.table && this.table.current) {
                                        this.table.current.reload();
                                    }
                                }, 0);
                            }}
                        >
                            Reset
                        </Button>
                    </div>
                ),

                filterIcon: function (filtered) {
                    return (
                        <Icon
                            type="search"
                            style={{ color: filtered ? "#1890ff" : undefined }}
                        />
                    );
                }
            },
            {
                title: "CP Name",
                render: function (r) {
                    return r.channelPartnerName || "-";
                }
            },
            // {
            //     title: "Commission",
            //     render: function (r) {

            //         // NEW STRUCTURE
            //         if (r.commissionsArr && r.commissionsArr.length > 0) {
            //             return (
            //                 <div>
            //                     {r.commissionsArr.map(function (item, index) {

            //                         const commissionType =
            //                             item.commissionTypeFrom === "Percentage"
            //                                 ? " (%)"
            //                                 : item.commissionTypeFrom === "Flat"
            //                                     ? " (Flat)"
            //                                     : "";

            //                         return (
            //                             <div key={index}>
            //                                 {`T${item.termNumber || index + 1}: ${item.commissionFromCourse}${commissionType}`}
            //                             </div>
            //                         );
            //                     })}
            //                 </div>
            //             );
            //         }

            //         return "-";
            //     }
            // },
            {
                title: "Commission",
                render: function (r) {

                    // Priority 1 - New Structure
                    if (r.commissionsArr && r.commissionsArr.length > 0) {
                        return (
                            <div>
                                {r.commissionsArr.map(function (item, index) {

                                    const commissionType =
                                        item.commissionTypeFrom === "Percentage"
                                            ? " (%)"
                                            : item.commissionTypeFrom === "Flat"
                                                ? " (Flat)"
                                                : "";

                                    return (
                                        <div key={index}>
                                            {`T${item.termNumber || index + 1}: ${item.commissionFromCourse}${commissionType}`}
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    }

                    // Priority 2 - Old Structure
                    if (
                        r.commissionFromCourse !== undefined &&
                        r.commissionFromCourse !== null &&
                        r.commissionFromCourse !== ""
                    ) {

                        const commissionType =
                            r.commissionTypeFrom === "Percentage"
                                ? " (%)"
                                : r.commissionTypeFrom === "Flat"
                                    ? " (Flat)"
                                    : "";

                        return (
                            <div>
                                {r.commissionFromCourse}
                                {commissionType}
                            </div>
                        );
                    }

                    return "-";
                }
            },
            {
                title: "Invoices",
                render: function (r) {
                    if (
                        r.noOfInvoice !== undefined &&
                        r.noOfInvoice !== null &&
                        r.noOfInvoice !== ""
                    ) {
                        return r.noOfInvoice;
                    }
                    return "-";
                }
            },
            {
                title: "Invoice / Year",
                render: function (r) {
                    if (
                        r.invoicePerYear !== undefined &&
                        r.invoicePerYear !== null &&
                        r.invoicePerYear !== ""
                    ) {
                        return r.invoicePerYear;
                    }
                    return "-";
                }
            },
            {
                title: "Created / Updated By",
                key: "userAudit",

                render: function (text, r) {

                    const user = (r && r.updatedByUser) || (r && r.createdByUser);

                    if (!user) return "-";

                    const name = user.name || "-";

                    let time = null;

                    // ✅ HANDLE ALL DATE FORMATS
                    if (user.time) {
                        if (typeof user.time === "string") {
                            time = new Date(user.time);
                        }
                        else if (user.time.$date && user.time.$date.$numberLong) {
                            time = new Date(parseInt(user.time.$date.$numberLong));
                        }
                        else if (user.time.$date) {
                            time = new Date(user.time.$date);
                        }
                        else {
                            time = new Date(user.time);
                        }
                    }

                    const formattedDate = time
                        ? time.toLocaleDateString() + " " + time.toLocaleTimeString()
                        : "-";

                    return (
                        <div>
                            <div>{name}</div>
                            <div style={{ fontSize: 12, color: "#888" }}>
                                {formattedDate}
                            </div>
                        </div>
                    );
                },

                // ✅ FILTER UI
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <div style={{ padding: 8 }}>
                        <RangePicker
                            showTime
                            style={{ marginBottom: 8, display: "block" }}
                            value={selectedKeys[0] || []}
                            onChange={(dates) => {
                                setSelectedKeys(dates ? [dates] : []);
                            }}
                        />

                        <Button
                            type="primary"
                            size="small"
                            style={{ width: 90, marginRight: 8 }}
                            onClick={() => {
                                confirm();

                                // ✅ SAFE reload (no optional chaining)
                                setTimeout(() => {
                                    if (this.table && this.table.current) {
                                        this.table.current.reload();
                                    }
                                }, 0);
                            }}
                        >
                            Filter
                        </Button>

                        <Button
                            size="small"
                            style={{ width: 90 }}
                            onClick={() => {
                                clearFilters();

                                // ✅ SAFE reload after reset
                                setTimeout(() => {
                                    if (this.table && this.table.current) {
                                        this.table.current.reload();
                                    }
                                }, 0);
                            }}
                        >
                            Reset
                        </Button>
                    </div>
                ),

                filterIcon: function (filtered) {
                    return (
                        <Icon
                            type="calendar"
                            style={{ color: filtered ? "#1890ff" : undefined }}
                        />
                    );
                }
            }

        ];
        return (
            <Drawer
                title={
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <span>
                            {icon || <Icon type="profile" />} {title}
                        </span>
                        <Tag className="count-tag">{count} TOTAL</Tag>
                    </div>
                }
                placement="right"
                onClose={this.onClose}
                visible={visible}
                width={1200}
                className={`dynamic-drawer ${bgColorClass}`}
            >
                {showAgreementDrawer && (
                    <ShowUniversityAgreement
                        record={agreementRecord}
                        onClose={this.closeAgreement}
                    />
                )}

                <TableComp
                    columns={columns}
                    ref={this.table}
                    apiRequest={this.apiRequest}
                    loading={loading}
                    rowKey={record => record._id}
                    extraProps={{ scroll: { x: 1000 } }}
                    pagination={{
                        showSizeChanger: true,
                        pageSizeOptions: ["10", "20", "50"]
                    }}
                />
            </Drawer>
        );
    }
}

export default connect()(UniversityCourseCommApporvalDrawer);
